import React from 'react';

import QueryString from 'qs';

import { Link } from '@mui/material';

import { operations } from '@luxuryescapes/contract-svc-promo';

import { queryParamNames } from '../hooks/usePromoCodes';

type PromoSearchLinkParams = {
  title: string;
  filter: operations['searchPromos']['parameters']['query'] & { is_dev?: boolean };
};

function PromoSearchLink({ filter, title }: PromoSearchLinkParams) {
  if (!filter.expires_after) {
    filter.expires_after = new Date().toISOString();
  }

  const qsString = QueryString.stringify({
    [queryParamNames.name]: filter.code_name,
    [queryParamNames.brand]: filter.brand,
    [queryParamNames.dev]: filter.is_dev,
    [queryParamNames.expiresAfter]: filter.expires_after,
    [queryParamNames.deptTag]: filter.dept_tag,
    [queryParamNames.categoryTag]: filter.category_tag,
    [queryParamNames.subCategoryTag]: filter.sub_category_tag,
  });
  return (
    <Link href={`/marketing/search-promo?${qsString}`} target="_blank">
      {title}
    </Link>
  );
}

export default PromoSearchLink;
